export class FormacaoPrecosNotaFiscalEntradaDialogData {
  idNFeEntrada = 0;
  numeroNota = '';
  nomeFornecedor = '';
}
